// extracted by mini-css-extract-plugin
export default {"notFoundMessage":"ImageNotFoundScreen_notFoundMessage__KvWtJ"};